import { PaymentFlowType } from '../constants/user-info/paymentFlowType';
import { apiService } from './apiService';
import { BillingType } from '../constants/user-info/billingType';

type GetPaymentFlowTypeResponse = { paymentFlowType: PaymentFlowType };
type BillingTypeResponse = { billingType: BillingType };

export const paymentService = {
  async getPaymentFlowType(entityId: number) {
    const resp = await apiService.get<GetPaymentFlowTypeResponse>(
      `api/entity/${entityId}/payment-flow`,
    );

    return resp.data;
  },

  async getBillingType(entityId: number) {
    const resp = await apiService.get<BillingTypeResponse>(
      `/api/entity/${entityId}/settings/billing-type`,
    );

    return resp.data;
  },

  async updateBillingType(entityId: number, billingType: BillingType) {
    const resp = await apiService.put<BillingTypeResponse>(
      `/api/entity/${entityId}/settings/billing-type`,
      { billingType },
    );

    return resp.data;
  },
};
